/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var QuestionCircleIcon16Regular = forwardRef('QuestionCircleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { d: "M6.76 6.348c0-.48.47-1.018 1.24-1.018s1.24.537 1.24 1.018c0 .359-.242.73-.695.913-.525.214-1.045.606-1.23 1.258a.75.75 0 1 0 1.444.409c.013-.046.07-.163.35-.277.92-.374 1.63-1.234 1.63-2.303C10.74 4.877 9.428 3.83 8 3.83c-1.427 0-2.74 1.047-2.74 2.518a.75.75 0 0 0 1.5 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
